import { AppNode } from "@features/builder/graph/types"
import { InfoOutlined } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import { memo } from "react"

type VersionsLimitedInfoProps = {
  linksPerVersion: Record<string, AppNode[]>
}

const VersionsLimitedInfo = memo((props: VersionsLimitedInfoProps) => {
  return (
    <Box sx={{ p: 2, color: "rgba(0, 0, 0, 0.6)" }}>
      <InfoOutlined fontSize="small" sx={{ verticalAlign: "bottom" }} />

      <Typography variant="caption">
        This graph versions were limited due to the fact that other nodes are linked to different
        versions. One graph can utilise only one version at a time.
      </Typography>

      <Typography variant="caption" sx={{ display: "block" }}>
        Existing links in the graph:
        {Object.entries(props.linksPerVersion).map(([version, nodes]) => (
          <Box key={version}>
            <strong>{version}</strong>: {nodes.map((node) => node.data.label).join(", ")}
          </Box>
        ))}
      </Typography>
    </Box>
  )
})

VersionsLimitedInfo.displayName = "VersionsLimitedInfo"

export default VersionsLimitedInfo
